import { Box, Card, CardContent, Grid, Skeleton, Stack } from '@mui/material';

interface LoadingSkeletonProps {
  variant?: 'page' | 'cards' | 'table' | 'detail';
  cardCount?: number;
}

export function LoadingSkeleton({
  variant = 'page',
  cardCount = 4,
}: LoadingSkeletonProps) {
  if (variant === 'cards') {
    return (
      <Grid container spacing={2.5}>
        {Array.from({ length: cardCount }).map((_, i) => (
          <Grid item xs={12} sm={6} md={3} key={i}>
            <Card>
              <CardContent>
                <Stack direction="row" justifyContent="space-between">
                  <Box sx={{ flex: 1 }}>
                    <Skeleton width="40%" height={14} sx={{ mb: 1.5 }} />
                    <Skeleton width="55%" height={36} />
                    <Skeleton width="70%" height={14} sx={{ mt: 1 }} />
                  </Box>
                  <Skeleton variant="rounded" width={48} height={48} sx={{ borderRadius: '14px' }} />
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }

  if (variant === 'table') {
    return (
      <Card>
        <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
          <Box sx={{ px: 2, py: 2, borderBottom: '1px solid', borderColor: 'divider' }}>
            <Skeleton width={180} height={24} />
          </Box>
          {Array.from({ length: 6 }).map((_, i) => (
            <Box
              key={i}
              sx={{
                display: 'flex',
                gap: 2,
                px: 2,
                py: 1.75,
                borderBottom: i < 5 ? '1px solid' : 'none',
                borderColor: 'divider',
              }}
            >
              <Skeleton variant="circular" width={36} height={36} />
              <Box sx={{ flex: 1 }}>
                <Skeleton width="35%" height={16} sx={{ mb: 0.75 }} />
                <Skeleton width="55%" height={12} />
              </Box>
              <Skeleton width={72} height={24} sx={{ borderRadius: 1 }} />
            </Box>
          ))}
        </CardContent>
      </Card>
    );
  }

  if (variant === 'detail') {
    return (
      <Stack spacing={2.5}>
        <Skeleton width="40%" height={32} />
        <Skeleton width="60%" height={18} />
        <Card>
          <CardContent>
            <Skeleton height={200} sx={{ borderRadius: 2 }} />
          </CardContent>
        </Card>
      </Stack>
    );
  }

  return (
    <Stack spacing={3}>
      <Box>
        <Skeleton width={200} height={32} sx={{ mb: 1 }} />
        <Skeleton width={280} height={18} />
      </Box>
      <LoadingSkeleton variant="cards" cardCount={cardCount} />
      <LoadingSkeleton variant="table" />
    </Stack>
  );
}
